module.exports = function (pageMetadataService) {
    return {
        restrict: 'E',
        scope: {},
        controller: [
            '$scope', function (scope) {
                this.$onInit = function() {
                    scope.metadata = pageMetadataService;
                    scope.$watch('metadata.title', function (newValue) {
                        scope.primaryHeader = newValue;
                        scope.hasPrimaryHeader = (typeof (scope.primaryHeader) !== 'undefined' && scope.primaryHeader.trim() !== '');
                    });
                };
            }
        ],
        template: '<div class="sr-only" ng-if="hasPrimaryHeader">{{primaryHeader}}</div>'
    };
};



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/accessiblity/primaryHeader/primary-header-directive.js
 **/